// ======================================================================
// File Name       : ContentLinkingDetailContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Col, Form, Row, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { destroy } from 'redux-form';
import { saveItem } from '../../actions/ItemAction';
import { openModal } from '../../actions/ModalAction';
import { Category, Item } from '../../components/Detail';
import ModalWrapper from '../../components/modal/ModalWrapper';
import {
  DEFAULT_DATE_FORMAT
} from '../../constants';
import UserAttributeDetailConfirmContainer from '../userAttribute/UserAttributeDetailConfirmContainer';

import * as actionTypeContainer from '../../constants/actionTypes/container';
import { SHOW_MESSAGE } from '../../constants/actionTypes/message';
import * as actionType from '../../constants/actionTypes/page';
import { CONTENT_TYPE, DATA_AFFIILIATION_TYPE } from '../../constants/ContentConstant';
import * as FunctionConstants from '../../constants/FunctionConstants';
import * as ModalIds from '../../constants/ModalIds';
import { canAccess } from '../../utils/AuthedUtils';
import * as courseUtils from '../../utils/CourseUtils';
import { handleReportDateTimeDetail } from '../../utils/index';
import * as containerActions from '../../actions/ContainerAction';
import TableHead from '../../components/TableHead';
import { START_CONDITION_TYPE_FOR_ITEM } from '../../constants/ItemConstant';

let okBtnClick = false;
class ContentLinkingDetailContainer extends Component {
  getModalOptions() {
    const { modalId, dispatch, itemInfo } = this.props;

    const { itemListForItemStart } = itemInfo;
    const contentLinkingDetailOption = {
      title: 'コンテンツ紐付け詳細',
      footerBtns: [{ name: 'キャンセル', onClick: this.props.hideModal, variant: 'default' }],
    };

    if (canAccess(FunctionConstants.CONTENT_LINKING_EDIT) && itemInfo.dataAffiliationType === DATA_AFFIILIATION_TYPE.INTERNAL) {
      contentLinkingDetailOption.footerBtns.push({
        name: '編集',
        // sprint_20230522_tma START
        onClick: () => {
          dispatch(containerActions.selectedItemOnDialog(itemListForItemStart));
          dispatch(openModal(ModalIds.CONTENT_LINKING_REGISTER_EDIT_DETAIL_SETTING));
        },
        // sprint_20230522_tma END
        variant: 'primary',
      });
    }

    const OPTIONS = {
      [ModalIds.CONTENT_LINKING_DETAIL]: contentLinkingDetailOption,
      [ModalIds.CONTENT_LINKING_CONFIRM]: {
        title: '以下の内容を登録します',
        footerBtns: [
          {
            name: '戻る',
            onClick: () => dispatch(openModal(ModalIds.CONTENT_LINKING_REGISTER_EDIT_DETAIL_SETTING)),
            variant: 'default',
          },
          {
            name: 'OK',
            onClick: () => {
              if (!okBtnClick) {
                okBtnClick = true;
                dispatch(saveItem()).then(() => {
                  okBtnClick = false;
                  this.props.dispatch({
                    type: actionType.CLEAR_SEARCH_CONDITION,
                  });
                  destroy(ModalIds.CONTENT_LINKING_DETAIL);
                  destroy(ModalIds.CONTENT_LINKING_CONFIRM);
                  destroy(ModalIds.CONTENT_LINKING_REGISTER_EDIT_DETAIL_SETTING);
                }).catch((error) => {
                  const messageInfo = {
                    statusCd: error.statusCd,
                    message: error.message,
                    targetModal: true,
                    messageType: 'danger',
                  };
                  dispatch(openModal(ModalIds.CONTENT_LINKING_REGISTER_EDIT_DETAIL_SETTING));
                  dispatch({ type: SHOW_MESSAGE, ...messageInfo });
                  okBtnClick = false;
                });
              }
            },
            variant: 'primary',
          },
        ],
      },
    };

    return OPTIONS[modalId];
  }

  closeModal() {
    this.props.dispatch({
      type: actionType.CLEAR_SEARCH_CONDITION,
    });
    this.props.hideModal();
  }

  render() {
    const { itemName, description, publicStatus, isItemReport, defaultThumbnail, publicPeriodFrom, publicPeriodTo } = this.props.itemInfo;
    const { endConditionTypeForItem, progressRatioForItemEnd, contentInfo } = this.props.itemInfo;
    let contentType = null;
    let contentSecernId = null;
    if (contentInfo) {
      contentType = contentInfo.contentType;
      contentSecernId = contentInfo.contentSecernId;
    }
    let { reportDeadline, reportReturnPlanDate } = this.props.reportInfo;
    if (isItemReport) {
      const format = DEFAULT_DATE_FORMAT;
      const dateTime = handleReportDateTimeDetail(reportReturnPlanDate, reportDeadline, format);
      reportReturnPlanDate = dateTime.dateTimeFromTxt;
      reportDeadline = dateTime.dateTimeToTxt;
    }
    let urlImg = <img src={defaultThumbnail} className="img-thumbnail" width="150" height="150" />;
    if (this.props.itemInfo && this.props.itemInfo.thumbnailUrl) {
      urlImg = <img src={this.props.itemInfo.thumbnailUrl} className="img-thumbnail" width="150" height="150" />
    }

    if (this.props.itemInfo && this.props.itemInfo.dataUrl) {
      urlImg = <img src={this.props.itemInfo.dataUrl} className="img-thumbnail" width="150" height="150" />
    }
    const displayPublicPeriod = courseUtils.getDisplayPublicPeriod(publicPeriodFrom, publicPeriodTo);
    // sprint_20230522_tma START
    const { startConditionTypeForItem, progressRatioForItemStart } = this.props.itemInfo; 
    const { selectedItemList, structures } = this.props;
    const displayStartConditionTypeForItem = courseUtils.getDisplayStartConditionTypeForItem(startConditionTypeForItem,progressRatioForItemStart);
    const thead = [
      { title: "コース表示名称", sortBy: null },
      { title: "親セクション名", sortBy: null },
    ];

    let dataTable = null;
    if (selectedItemList && selectedItemList.length) {
      dataTable = selectedItemList.map((cur, index) => {
        let itemNameWithTable = '';
        let boxNameWithItem = '';
        let boxIdWithItem='';
        if (
          Object.keys(structures.bySecernId).length &&
          structures.bySecernId[cur.itemSecernId]
        ) {
          itemNameWithTable = structures.bySecernId[cur.itemSecernId].structureName;
          boxIdWithItem = structures.bySecernId[cur.itemSecernId].parentBoxSecernId;
          boxNameWithItem = structures.bySecernId[boxIdWithItem].structureName;
        }
        return (
          <tr key={index}>
            <td>{itemNameWithTable}</td>
            <td>{boxNameWithItem}</td>
          </tr>
        );
      });
    }
    const startConditionDataTable = (
      <Table striped hover>
        <thead>
          <TableHead data={thead} />
        </thead>
        <tbody>{dataTable}</tbody>
      </Table>
    );
    // sprint_20230522_tma END
    return (
      <ModalWrapper {...this.getModalOptions()} hideModal={this.closeModal.bind(this)} dialogClassName="modal-width-950">
        <Form className='form-horizontal margin-left-right-minus-15'>
          <Category label="基本設定" />
          <Item name="コンテンツ識別ID" value={contentSecernId} indent={1} />
          <Item name="コース表示名称" value={itemName} indent={1} />
          <Item name="説明" value={description} indent={1} />
          <Item name="公開ステータス" value={publicStatus === 1 ? '公開' : '非公開'} indent={1} />
          <Item name="サムネイル画像" value={urlImg} indent={1} formClassName="label-middle" />
          <Category label="詳細設定" />
          <Item name="公開期間" value={displayPublicPeriod} indent={1} />
          {/* sprint_20230522_tma START */}
          <Form.Group className="form-info">
            <Col sm={3} as={Form.Label}>
              <div style={{ paddingLeft: '15px' }}>
                コンテンツ開始条件
              </div>
            </Col>
            <Col sm={9} as={Form.Label}>
              {displayStartConditionTypeForItem}
            </Col>
            {startConditionTypeForItem !== START_CONDITION_TYPE_FOR_ITEM.NO_CONDITION && (
              <Col sm={12} className="margin-top-10 padding-left-30 padding-right-15">
                {startConditionDataTable}
              </Col>
            )}
          </Form.Group>
          {/* sprint_20230522_tma END */}
          <Item
            name="コンテンツ完了条件"
            value={
              !endConditionTypeForItem
                ? 'なし'
                : contentType === CONTENT_TYPE.DRILL && parseInt(progressRatioForItemEnd, 10) > 0
                  ? `正答率：${progressRatioForItemEnd}%`
                  : 'コンテンツ実施'
            }
            indent={1}
          />
          {isItemReport &&
            <div>
              <Item name="レポート提出期限" value={reportDeadline} indent={1} />
              <Item name="レポート結果返却予定日" value={reportReturnPlanDate} indent={1} className="padding-right-clear" />
            </div>}
          <UserAttributeDetailConfirmContainer titleClass="padding-left-30" leftClass="padding-left-45" />
        </Form>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const itemInfo = state.item.edittingItem;
  const reportInfo = state.report.editingReport;
  // sprint_20230522_tma START
  const { structures } = state.container;
  let selectedItemList;
  if (state.container.selectedItemList && Object.keys(state.container.selectedItemList).length) {
    selectedItemList = state.container.selectedItemList;
  } else {
    selectedItemList = state.item.selectedItemList;
  }
  return {
    itemInfo,
    reportInfo,
    selectedItemList,
    structures,
  };
  // sprint_20230522_tma END
};

export default connect(mapStateToProps)(ContentLinkingDetailContainer);
